/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Price_OverlineInputs */

const en_cp_price_overline = /** @type {(inputs: Cp_Price_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRICING`)
};

const id_cp_price_overline = /** @type {(inputs: Cp_Price_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HARGA`)
};

/**
* | output |
* | --- |
* | "PRICING" |
*
* @param {Cp_Price_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_price_overline = /** @type {((inputs?: Cp_Price_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Price_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_price_overline(inputs)
	return en_cp_price_overline(inputs)
});